"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _1 = require(".");
var inversify_1 = require("inversify");
var Root = /** @class */ (function () {
    function Root(maintenance) {
        this.maintenance = maintenance;
    }
    var _a;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MaintenanceClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MaintenanceClient !== "undefined" && _1.MaintenanceClient) === "function" ? _a : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;
